import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'disputes.create-select',
    country: ['IL']
  },
  {
    feature: 'dispute-detail.use-comment-categories',
    country: ['IL'],
    role_any:
      ['ARMSTAFFDM', 'ARMSTAFFARC', 'ARMSTAFFSR', 'ARMSTAFFSRCEMENT', 'ARMSTAFFSRMCEMENT', 'ARMSTAFFSRM', 'ARMSTAFFSCONF']
  },
  {
    feature: 'dispute.dispute-detail-jobsite-info',
    country: ['ES']
  },
  {
    feature: 'dispute.modal-confirmation',
    country: ['IL'],
    role_any:
      'ARMORGAPC, ARMORGARCADV,ARMORGRECONCILE,ARMORGLIEN,ARMORGAPS,ARMORGARU,ARMORGCASH,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,ARMSTAFFSCONF,Application,OPC_FORMAN,OPC_PO_MGR,OPC_CUST_OWNER'
  },
  {
    feature: 'dispute.table-columns',
    country: ['ES', 'LV'],
    role_any:
      'ARMORGAPC, ARMORGARCADV,ARMORGRECONCILE,ARMORGLIEN,ARMORGAPS,ARMORGARU,ARMORGCASH,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,ARMSTAFFSCONF,Application,OPC_FORMAN,OPC_PO_MGR,OPC_CUST_OWNER'
  },
  {
    feature: 'dispute.table-detail-es',
    country: ['ES', 'LV'],
    role_any:
      'ARMORGAPC, ARMORGARCADV,ARMORGRECONCILE,ARMORGLIEN,ARMORGAPS,ARMORGARU,ARMORGCASH,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,ARMSTAFFSCONF,Application,OPC_FORMAN,OPC_PO_MGR,OPC_CUST_OWNER'
  },
  {
    feature: 'dispute-create.table',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'FR',
      'PA',
      'CR',
      'NI',
      'SV',
      'ES',
      'LV',
      'IL',
      'CZ',
      'GT',
      'DO',
      'PR',
      'PE',
      'PH',
      'PL'
    ],
    options: {
      columns: [
        {
          name: 'referenceNumber',
          width: '20'
        },
        {
          name: 'dueDate',
          width: '20'
        },
        {
          name: 'location',
          width: '40'
        },
        {
          name: 'remainingBalance',
          width: '20'
        }
      ]
    }
  },
  {
    feature: 'dispute-create.table',
    country: ['US'],
    options: {
      columns: [
        {
          name: 'invoiceNumber',
          width: '20'
        },
        {
          name: 'dueDate',
          width: '20'
        },
        {
          name: 'location',
          width: '40'
        },
        {
          name: 'remainingBalance',
          width: '20'
        }
      ]
    }
  },
  {
    feature: 'dispute-creation.disclaimer',
    country: ['ES', 'LV'],
    options: {
      header: 'views.disclaimer.disputeCreation.disclaimer_header',
      body: 'views.disclaimer.disputeCreation.disclaimer_body'
    }
  },
  {
    feature: 'dispute-creation.message',
    country: ['LV']
  },
  {
    feature: 'dispute-creation.attachment-required',
    country: ['IL']
  },

  {
    feature: 'disputes.filter-category-special-invoice',
    country: ['MX']
  },
  {
    feature: 'credit-note-requests.table-template',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'GT',
      'DO',
      'PR',
      'PE',
      'IL',
      'PH',
      'PL',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'disputeStatusDesc',
          'disputeDate',
          'disputeCode',
          'disputeCategoryDesc',
          'customerDesc',
          'responsibleUserName',
          'lastComment'
        ],
        inactive: [],
        hidden: []
      }
    }
  },
  {
    feature: 'dispute.date-limit-creation',
    country: ['AE'],
    options: {
      max_range_days: 30
    }
  },
  {
    feature: 'dispute-detail.delete-comment',
    role_any: ['ARMSTAFFDM']
  },
  {
    feature: 'dispute-access',
    options: {
      applications: ['Construagil_App']
    }
  },
] as IAppConfiguration[];
